/* ============================================================
   Beni Support Ticket —— 前端交互 (本期 UI-only)
   - 情况下拉(已购/售前)条件显隐 + 描述 label 切换
   - 行内校验 + 全局错误条
   - 文件上传：仅本地校验(格式 + 累计大小),不真上传
   - SN 帮助弹窗
   - 提交：stub(校验通过即展示成功卡)
   详见 docs/寄修方案实施清单.md 第 9 节。
   ============================================================ */
(function () {
  'use strict';

  var MSG = {
    required: 'This field is required',
    email: 'Please enter a valid email address',
    badType: 'Unsupported file type.',
    tooBig: 'Upload failed. File exceeds maximum size limit.'
  };

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  var ICON = {
    file: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M10.4999 1.49903H4.50045C4.10267 1.49903 3.72117 1.65707 3.4399 1.9384C3.15862 2.21973 3.0006 2.60129 3.0006 2.99915V15.0001C3.0006 15.398 3.15862 15.7795 3.4399 16.0608C3.72117 16.3422 4.10267 16.5002 4.50045 16.5002H13.4996C13.8973 16.5002 14.2788 16.3422 14.5601 16.0608C14.8414 15.7795 14.9994 15.398 14.9994 15.0001V5.99938M10.4999 1.49903C10.7372 1.49864 10.9724 1.54523 11.1917 1.63611C11.411 1.727 11.6102 1.86037 11.7777 2.02857L14.4685 4.71978C14.6371 4.88743 14.7708 5.08682 14.8619 5.30645C14.9531 5.52608 14.9998 5.76159 14.9994 5.99938M10.4999 1.49903V5.24932C10.4999 5.44825 10.5789 5.63903 10.7195 5.77969C10.8601 5.92036 11.0509 5.99938 11.2498 5.99938L14.9994 5.99938" stroke="#C53523" stroke-width="2" stroke-linecap="round"/></svg>',
    check: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M13.3328 4L6.00018 11.3328L2.66718 7.99971" stroke="#16A34A" stroke-width="2" stroke-linecap="round"/></svg>',
    trash: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>',
    retry: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>'
  };

  var uid = 0;

  function formatSize(bytes) {
    if (bytes >= 1048576) return (bytes / 1048576).toFixed(1) + ' MB';
    if (bytes >= 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return bytes + ' B';
  }

  function extOf(name) {
    var m = /\.([a-z0-9]+)$/i.exec(name || '');
    return m ? m[1].toLowerCase() : '';
  }

  // MIME -> 允许的扩展名(用于 file.type 为空时兜底)
  var MIME_EXT = {
    'image/jpeg': ['jpg', 'jpeg'],
    'image/png': ['png'],
    'image/webp': ['webp'],
    'video/mp4': ['mp4']
  };

  function typeAllowed(file, acceptList) {
    if (!acceptList.length) return true;
    if (file.type && acceptList.indexOf(file.type) !== -1) return true;
    // file.type 为空/不匹配 → 用扩展名兜底
    var ext = extOf(file.name);
    for (var i = 0; i < acceptList.length; i++) {
      var exts = MIME_EXT[acceptList[i]] || [];
      if (exts.indexOf(ext) !== -1) return true;
    }
    return false;
  }

  /* ---------------- 情况下拉：条件显隐 ---------------- */
  function applyMode(form) {
    var select = form.querySelector('[data-situation]');
    if (!select) return;
    var mode = select.value; // owner | order | presales

    // data-when 支持多值(空格分隔)：字段可同时归属多个情况分支(如 owner 与 order 共用采购渠道/订单号)
    form.querySelectorAll('[data-when]').forEach(function (el) {
      var whens = el.getAttribute('data-when').split(/\s+/);
      el.hidden = whens.indexOf(mode) === -1;
    });

    var descLabel = form.querySelector('[data-label-owner]');
    if (descLabel) {
      var next = descLabel.getAttribute('data-label-' + mode);
      if (next) descLabel.textContent = next;
    }
  }

  /* ---------------- 自定义下拉(div 实现) ---------------- */
  function wireDropdown(dd, form) {
    if (dd._wired) return;
    dd._wired = true;

    var toggle = dd.querySelector('[data-dropdown-toggle]');
    var menu = dd.querySelector('[data-dropdown-menu]');
    var valueEl = dd.querySelector('[data-dropdown-value]');
    var input = dd.querySelector('[data-dropdown-input]');
    var options = Array.prototype.slice.call(dd.querySelectorAll('[data-dropdown-option]'));
    if (!toggle || !menu || !input || !options.length) return;

    function isOpen() { return !menu.hidden; }

    function onDocClick(e) { if (!dd.contains(e.target)) closeMenu(); }

    function openMenu() {
      menu.hidden = false;
      dd.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      var sel = options.filter(function (o) { return o.getAttribute('aria-selected') === 'true'; })[0] || options[0];
      if (sel) sel.focus();
      document.addEventListener('click', onDocClick, true);
    }

    function closeMenu() {
      menu.hidden = true;
      dd.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onDocClick, true);
    }

    function mark(opt) {
      options.forEach(function (o) {
        var on = o === opt;
        o.setAttribute('aria-selected', on ? 'true' : 'false');
        o.classList.toggle('is-selected', on);
      });
      input.value = opt.getAttribute('data-value');
      // innerHTML 而非 textContent：选项支持 inline_richtext（加粗等），选中态需保留格式
      valueEl.innerHTML = (opt.innerHTML || '').trim();
    }

    function choose(opt) {
      mark(opt);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      closeMenu();
      toggle.focus();
    }

    // 初始同步(以标注 aria-selected 的项为准，回填 hidden 值与显示文案)
    var current = options.filter(function (o) { return o.getAttribute('aria-selected') === 'true'; })[0] || options[0];
    if (current) mark(current);

    toggle.addEventListener('click', function () { isOpen() ? closeMenu() : openMenu(); });

    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (!isOpen()) openMenu();
      }
    });

    menu.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-dropdown-option]');
      if (opt) choose(opt);
    });

    menu.addEventListener('keydown', function (e) {
      var idx = options.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        (options[idx + 1] || options[0]).focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        (options[idx - 1] || options[options.length - 1]).focus();
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (options[idx]) choose(options[idx]);
      } else if (e.key === 'Escape') {
        e.preventDefault();
        closeMenu();
        toggle.focus();
      } else if (e.key === 'Tab') {
        closeMenu();
      }
    });
  }

  /* ---------------- 校验 ---------------- */
  function isActive(el) {
    // 处于隐藏的 [data-when] 分支内 → 不校验
    var branch = el.closest('[data-when]');
    return !(branch && branch.hidden);
  }

  function fieldOf(el) {
    return el.closest('[data-field]');
  }

  // 隐藏的下拉输入无法可见聚焦 → 改聚焦其可见的下拉按钮
  function focusControl(el) {
    if (el && el.type === 'hidden') {
      var dd = el.closest('[data-dropdown]');
      var toggle = dd && dd.querySelector('[data-dropdown-toggle]');
      if (toggle) { toggle.focus(); return; }
    }
    if (el) el.focus();
  }

  function setFieldError(field, msg) {
    if (!field) return;
    field.classList.add('is-error');
    var err = field.querySelector('[data-error]');
    if (err) {
      err.textContent = msg;
      err.hidden = false;
    }
  }

  function clearFieldError(field) {
    if (!field) return;
    field.classList.remove('is-error');
    var err = field.querySelector('[data-error]');
    if (err) {
      err.textContent = '';
      err.hidden = true;
    }
  }

  function validate(form) {
    var firstBad = null;
    var controls = form.querySelectorAll('input, select, textarea');

    controls.forEach(function (el) {
      if (el.type === 'file' || !isActive(el)) return;
      var field = fieldOf(el);
      if (!field) return;
      clearFieldError(field);

      var val = (el.value || '').trim();
      var required = el.getAttribute('data-required') === 'true';

      if (required && !val) {
        setFieldError(field, MSG.required);
        firstBad = firstBad || el;
        return;
      }
      if (el.getAttribute('data-validate') === 'email' && val && !EMAIL_RE.test(val)) {
        setFieldError(field, MSG.email);
        firstBad = firstBad || el;
      }
    });

    return firstBad;
  }

  // 提交前:可见(isActive)上传区里是否有校验失败(error)的附件 → 返回首个出错的上传区(供拦截+定位)
  function firstErrorZone(form) {
    var bad = null;
    form.querySelectorAll('[data-upload]').forEach(function (zone) {
      if (bad || !isActive(zone)) return;
      if ((zone._files || []).some(function (e) { return e.status === 'error'; })) bad = zone;
    });
    return bad;
  }

  /* ---------------- 文件上传 ---------------- */
  function totalOkBytes(form, exceptEntry) {
    var sum = 0;
    form.querySelectorAll('[data-upload]').forEach(function (zone) {
      (zone._files || []).forEach(function (e) {
        if (e.status === 'ok' && e !== exceptEntry) sum += e.file.size;
      });
    });
    return sum;
  }

  function evaluate(entry, zone, form, maxTotal, acceptList) {
    if (!typeAllowed(entry.file, acceptList)) {
      entry.status = 'error';
      entry.msg = MSG.badType;
      return;
    }
    if (totalOkBytes(form, entry) + entry.file.size > maxTotal) {
      entry.status = 'error';
      entry.msg = MSG.tooBig;
      return;
    }
    entry.status = 'ok';
    entry.msg = '';
  }

  function renderZone(zone) {
    var list = zone.querySelector('[data-file-list]');
    var dropzone = zone.querySelector('[data-dropzone]');
    var addMore = zone.querySelector('[data-add-more]');
    var files = zone._files || [];

    list.innerHTML = '';
    files.forEach(function (entry) {
      var li = document.createElement('li');
      li.className = 'beni-st__file-row' + (entry.status === 'error' ? ' is-error' : '');
      li.dataset.id = entry.id;

      var actions = entry.status === 'error'
        ? '<button type="button" class="beni-st__icon-btn beni-st__icon-btn--retry" data-retry aria-label="Retry">' + ICON.retry + '</button>'
        : '<span class="beni-st__file-status">' + ICON.check + '</span>';

      li.innerHTML =
        '<span class="beni-st__file-icon">' + ICON.file + '</span>' +
        '<div class="beni-st__file-meta">' +
          '<span class="beni-st__file-name">' + escapeHtml(entry.file.name) + '</span>' +
          '<span class="beni-st__file-size">' + formatSize(entry.file.size) + '</span>' +
          (entry.status === 'error' ? '<span class="beni-st__file-msg">' + escapeHtml(entry.msg) + '</span>' : '') +
        '</div>' +
        '<div class="beni-st__file-actions">' + actions +
          '<button type="button" class="beni-st__icon-btn" data-remove aria-label="Remove">' + ICON.trash + '</button>' +
        '</div>';

      list.appendChild(li);
    });

    var hasFiles = files.length > 0;
    dropzone.hidden = hasFiles;
    list.hidden = !hasFiles;
    addMore.hidden = !hasFiles;
    zone.classList.toggle('has-files', hasFiles);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function addFiles(zone, form, fileList) {
    var maxTotal = parseInt(form.getAttribute('data-max-total'), 10) || Infinity;
    var acceptList = (zone.getAttribute('data-accept') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    zone._files = zone._files || [];

    Array.prototype.forEach.call(fileList, function (file) {
      var entry = { id: 'f' + (++uid), file: file, status: 'ok', msg: '' };
      evaluate(entry, zone, form, maxTotal, acceptList);
      zone._files.push(entry);
    });

    renderZone(zone);
  }

  function reevaluateAll(form) {
    // 移除文件后总量变化 → 重新评估所有 error(可能因超总量而失败的项现在通过)
    form.querySelectorAll('[data-upload]').forEach(function (zone) {
      var maxTotal = parseInt(form.getAttribute('data-max-total'), 10) || Infinity;
      var acceptList = (zone.getAttribute('data-accept') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      (zone._files || []).forEach(function (entry) {
        if (entry.status === 'error' && entry.msg === MSG.tooBig) {
          evaluate(entry, zone, form, maxTotal, acceptList);
        }
      });
      renderZone(zone);
    });
  }

  function wireUpload(zone, form) {
    var input = zone.querySelector('[data-file-input]');
    var dropzone = zone.querySelector('[data-dropzone]');
    var addMore = zone.querySelector('[data-add-more]');
    zone._files = [];

    function pick() { input.click(); }
    dropzone.addEventListener('click', pick);
    addMore.addEventListener('click', pick);

    input.addEventListener('change', function () {
      if (input.files && input.files.length) addFiles(zone, form, input.files);
      input.value = '';
    });

    // 拖放
    ['dragenter', 'dragover'].forEach(function (evt) {
      zone.addEventListener(evt, function (e) {
        e.preventDefault();
        zone.classList.add('is-dragover');
      });
    });
    ['dragleave', 'drop'].forEach(function (evt) {
      zone.addEventListener(evt, function (e) {
        e.preventDefault();
        if (evt === 'dragleave' && zone.contains(e.relatedTarget)) return;
        zone.classList.remove('is-dragover');
      });
    });
    zone.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
        addFiles(zone, form, e.dataTransfer.files);
      }
    });

    // 行内操作：移除 / 重试
    zone.querySelector('[data-file-list]').addEventListener('click', function (e) {
      var row = e.target.closest('[data-id]');
      if (!row) return;
      var id = row.dataset.id;

      if (e.target.closest('[data-remove]')) {
        zone._files = zone._files.filter(function (x) { return x.id !== id; });
        renderZone(zone);
        reevaluateAll(form);
      } else if (e.target.closest('[data-retry]')) {
        var maxTotal = parseInt(form.getAttribute('data-max-total'), 10) || Infinity;
        var acceptList = (zone.getAttribute('data-accept') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        var entry = zone._files.filter(function (x) { return x.id === id; })[0];
        if (entry) { evaluate(entry, zone, form, maxTotal, acceptList); renderZone(zone); }
      }
    });
  }

  /* ---------------- 弹窗 ---------------- */
  function wireModal(root) {
    var modal = root.querySelector('[data-modal="sn"]');
    if (!modal) return null;
    var lastFocus = null;
    var dialog = modal.querySelector('.beni-st-modal__dialog');

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      // 强制 reflow 以触发过渡
      void modal.offsetWidth;
      modal.classList.add('is-open');
      document.documentElement.classList.add('beni-st-modal-open');
      if (dialog) dialog.focus();
    }
    function close() {
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('beni-st-modal-open');
      var done = function () { modal.hidden = true; modal.removeEventListener('transitionend', done); };
      modal.addEventListener('transitionend', done);
      setTimeout(function () { if (!modal.hidden) done(); }, 400);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    modal.querySelectorAll('[data-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    return { open: open };
  }

  /* ---------------- 提交 ---------------- */
  function showSuccess(root, form) {
    var success = root.querySelector('[data-success]');
    form.hidden = true;
    if (success) {
      success.hidden = false;
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // 后端 error code → 用户可读文案
  var SUBMIT_ERR = {
    not_logged_in: 'Please sign in to your account before submitting.',
    invalid_signature: 'Something went wrong. Please refresh the page and try again.',
    customer_email_not_found: 'We could not read your account email. Please contact support.',
    uploads_not_configured: 'File upload is temporarily unavailable. Please try again later.',
    unsupported_type: 'One of your files has an unsupported format.',
    description_required: 'Please describe your issue.'
  };
  function submitErrorMsg(code) {
    return SUBMIT_ERR[code] || 'Submission failed. Please try again.';
  }

  // 收集活动字段(跳过隐藏分支 + 文件)
  function collectPayload(form) {
    var data = {};
    form.querySelectorAll('input, textarea').forEach(function (el) {
      if (el.type === 'file' || !el.name || !isActive(el)) return;
      data[el.name] = (el.value || '').trim();
    });
    return data;
  }

  // 逐个附件:要预签名 → 直传 S3 → 收集 key
  function uploadAttachments(form, base) {
    var jobs = [];
    form.querySelectorAll('[data-upload]').forEach(function (zone) {
      if (!isActive(zone)) return; // 隐藏分支(售前)不传
      (zone._files || []).forEach(function (entry) {
        if (entry.status !== 'ok') return;
        jobs.push(entry.file);
      });
    });

    return jobs.reduce(function (chain, file) {
      return chain.then(function (acc) {
        return fetch(base + '/upload-url', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ filename: file.name, content_type: file.type || 'application/octet-stream' })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok || !res.j.ok) throw new Error(submitErrorMsg(res.j && res.j.error));
            return fetch(res.j.url, {
              method: 'PUT',
              headers: { 'Content-Type': file.type || 'application/octet-stream' },
              body: file
            }).then(function (put) {
              if (!put.ok) throw new Error('Upload failed. Please try again.');
              acc.push({ key: res.j.key, filename: file.name, content_type: file.type || 'application/octet-stream' });
              return acc;
            });
          });
      });
    }, Promise.resolve([]));
  }

  function setSubmitting(btn, on, busyLabel) {
    if (!btn) return;
    if (on) {
      btn._label = btn.textContent;
      btn.textContent = busyLabel || 'Submitting…';
      btn.disabled = true;
    } else {
      if (btn._label) btn.textContent = btn._label;
      btn.disabled = false;
    }
  }

  // 提交等待态：锁住整个表单（防中途改字段/切下拉/加删附件导致数据串号）
  // 记录被本函数禁用的控件，恢复时只放开这些，避免误开原本就 disabled 的
  function setBusy(form, on) {
    if (on) {
      if (document.activeElement && form.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      form._busyLocked = [];
      form.querySelectorAll('input, textarea, button').forEach(function (el) {
        if (!el.disabled) { el.disabled = true; form._busyLocked.push(el); }
      });
      form.setAttribute('aria-busy', 'true');
      form.classList.add('is-submitting');
    } else {
      (form._busyLocked || []).forEach(function (el) { el.disabled = false; });
      form._busyLocked = null;
      form.removeAttribute('aria-busy');
      form.classList.remove('is-submitting');
    }
  }

  function submitForm(form, root, banner) {
    var base = form.getAttribute('data-proxy-base') || '/apps/repair';
    var busyLabel = form.getAttribute('data-submitting-label') || 'Submitting…';
    var btn = form.querySelector('[data-submit]');

    if (banner) banner.hidden = true;
    setSubmitting(btn, true, busyLabel); // 先禁提交按钮（含文案切换）
    setBusy(form, true); // 再锁其余控件（提交按钮已 disabled，会被跳过）

    uploadAttachments(form, base)
      .then(function (attachments) {
        var payload = collectPayload(form);
        payload.attachments = attachments;
        return fetch(base + '/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.j.ok) throw new Error(submitErrorMsg(res.j && res.j.error));
        showSuccess(root, form);
      })
      .catch(function (err) {
        setSubmitting(btn, false);
        setBusy(form, false); // 失败:解锁整表单(恢复被禁用的控件 + 去掉 is-submitting/aria-busy),保留已填内容与附件供重试
        if (banner) {
          var span = banner.querySelector('span');
          if (span) span.textContent = err.message || 'Submission failed. Please try again.';
          banner.hidden = false;
          banner.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
  }

  /* ---------------- 初始化 ---------------- */
  function initForm(form) {
    if (form._beniStInit) return;
    form._beniStInit = true;

    var root = form.closest('.beni-st');
    var banner = form.querySelector('[data-banner]');
    var modal = wireModal(root);

    // 自定义下拉(情况 / 采购渠道)
    form.querySelectorAll('[data-dropdown]').forEach(function (dd) { wireDropdown(dd, form); });

    // 情况下拉驱动条件显隐
    var situation = form.querySelector('[data-situation]');
    if (situation) situation.addEventListener('change', function () { applyMode(form); });
    applyMode(form);

    // 上传区
    form.querySelectorAll('[data-upload]').forEach(function (zone) { wireUpload(zone, form); });

    // 帮助链接 → 弹窗 (qr 暂无稿 → 无 modal 时静默)
    form.querySelectorAll('[data-open-modal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('data-open-modal') === 'sn' && modal) modal.open();
      });
    });

    // 编辑输入即清错
    form.addEventListener('input', function (e) {
      var field = fieldOf(e.target);
      if (field && field.classList.contains('is-error')) clearFieldError(field);
    });

    // 提交:校验 → 附件预签名直传 → POST /submit(同域,经 App Proxy)
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var firstBad = validate(form);
      // 字段校验后再拦附件:有 error 附件却放行会被 uploadAttachments 静默丢弃,却仍报提交成功
      var badZone = firstErrorZone(form);
      if (firstBad || badZone) {
        if (banner) {
          var span = banner.querySelector('span');
          // 字段错误优先提示;仅附件出错时给专用文案
          if (span) span.textContent = firstBad
            ? 'Please fix the errors below before submitting'
            : 'Please remove or replace the failed attachment before submitting.';
          banner.hidden = false;
        }
        if (firstBad) focusControl(firstBad);
        else badZone.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      submitForm(form, root, banner);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-beni-st-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // 主题编辑器：section 重载时重新初始化
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
